/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';

const StatusTracking = ({ ROSSStatus, ROSSOrderPendingCancel, IsPendingCancelEnabled }) => {
   
    const ROSSPendingCancelImg = <img className="ROSS-status-img" alt="pending cancel" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt8406336d422ecfc8/611fdd93e8898d66a7c9552b/Cancel_Pending_Bar.svg" />;
    const ROSSPendingCancel = ROSSOrderPendingCancel && ROSSStatus !== 'C';

    const renderROSSStatus = () => {
        switch (ROSSStatus) {
            case 'CANCELLED':
                return <img className="ROSS-status-img" alt="canceled" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt106cee8300a62b2e/5f9715e5f9cf41781dad39c8/cancelled.svg" />;
            case 'CONFIRMED':
                return <img className="ROSS-status-img" alt="confirmed" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt99d25268b9941e32/5f9715bf1f9166620ed85bce/confirmed.svg" />;
            case 'IN TRANSIT':
                return <img className="ROSS-status-img" alt="in transit" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt3bba57afd41534f4/5f9715bf209f0756c89d3d1b/in-transit.svg" />;
            case 'DELIVERED':
                return <img className="ROSS-status-img" alt="delivered" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/bltb2c40ac227b0cabd/5f9715bacb9eba781f084dff/delivered.svg" />;
            default:
                return <img className="ROSS-status-img" alt="confirmed" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt99d25268b9941e32/5f9715bf1f9166620ed85bce/confirmed.svg" />;
        }
    };

    return ROSSStatus ? (
        <div className="orderDetail">
            {IsPendingCancelEnabled && ROSSPendingCancel ? ROSSPendingCancelImg : renderROSSStatus()}
        </div>
    ) : null
};

StatusTracking.defaultProps = {
    ROSSStatus: '',
    ROSSOrderPendingCancel: false,
    IsPendingCancelEnabled: false,
};

StatusTracking.propTypes = {
    ROSSStatus: PropTypes.string,
    ROSSOrderPendingCancel: PropTypes.bool,
    IsPendingCancelEnabled: PropTypes.bool,
};

export default StatusTracking;
